import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldValidationDirective,
  DurationInputComponent as UICoreDIC,
} from '@softline/ui-core';
import { DurationDefinition } from '../../../../data/definitions';
import { BooleanRulePipe } from '../../../../pipes/boolean-rule.pipe';
import { DynamicInputAtom } from '../dynamic-input-atom';
import { FormControlPipe } from '../../../../pipes/form-control-name.pipe';
import { FormatRulePipe } from '../../../../pipes/format-rule.pipe';

@Component({
  selector: 'soft-dynamic-duration-input',
  templateUrl: './duration-input.component.html',
  styleUrls: ['./duration-input.component.css'],
  imports: [
    UICoreDIC,
    ReactiveFormsModule,
    FieldValidationDirective,
    BooleanRulePipe,
    FormControlPipe,
    FormatRulePipe,
  ],
})
export class DurationInputComponent
  extends DynamicInputAtom<DurationDefinition>
  implements OnInit
{
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
